import moment from "moment";

export interface IPaymentMethodConstructorParams {
	mask: string;
	name: string;
	expiry: string;
	cc_type: string;
	payment_type: string;
}

class PaymentMethod {
	public static EmptyConstructorParams: IPaymentMethodConstructorParams = {
		cc_type: "",
		expiry: "",
		mask: "",
		name: "",
		payment_type: "",
	};

	public static ConstructEmpty(): PaymentMethod {
		return PaymentMethod.Construct(PaymentMethod.EmptyConstructorParams);
	}

	public static Construct(
		params: IPaymentMethodConstructorParams,
	): PaymentMethod {
		return new PaymentMethod(params);
	}

	responseData: IPaymentMethodConstructorParams;

	constructor(params: IPaymentMethodConstructorParams) {
		this.responseData = params;
	}

	get mask(): string | null {
		if (!this.responseData.mask || this.responseData.mask === "") {
			return null;
		}

		return this.responseData.mask;
	}

	get name(): string {
		return this.responseData.name;
	}

	get expiry(): string | null {
		if (!this.responseData.expiry || this.responseData.expiry === "") {
			return null;
		}

		return this.responseData.expiry;
	}

	get ccType(): string {
		return this.responseData.cc_type;
	}

	get paymentType(): string {
		return this.responseData.payment_type;
	}

	get last4Digits(): string | null {
		if (!this.mask) {
			return null;
		}

		return this.mask.substring(this.mask.length - 4);
	}

	get isExpired(): boolean {
		if (!this.expiry) return false;
		const expiryDate = moment(this.expiry, "MM/YY").endOf("month");
		const today = moment();
		return today.isAfter(expiryDate);
	}
}

export default PaymentMethod;
